import { Auth } from 'aws-amplify';
import { AxiosInterceptorManager, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { ApiError } from 'domains/api/errors';
import { start, stop } from 'domains/api/global-progress';

/**
 * @NOTE(shawk): amplify-js will automatically handle refreshing the
 * access token when necessary.
 */
const getAccessJwtToken = async () => {
  const session = await Auth.currentSession();
  return session.getAccessToken().getJwtToken();
};

/** Will handle including the required authentication headers into the requests */
export const cognitoAuthRequestInterceptor: Parameters<AxiosInterceptorManager<InternalAxiosRequestConfig>['use']> = [
  async request => {
    start(true);

    if (request && request.headers) {
      const token = await getAccessJwtToken();
      request.headers.Authorization = `Bearer ${token}`;
    }

    return request;
  },
  error => {
    stop(true);
    return Promise.reject(ApiError.wrap(error));
  },
];

/** Will only track the request using global-progress */
export const unauthenticatedRequestInterceptor: Parameters<AxiosInterceptorManager<InternalAxiosRequestConfig>['use']> =
  [
    async request => {
      start(true);

      return request;
    },
    error => {
      stop(true);
      return Promise.reject(ApiError.wrap(error));
    },
  ];

/** Will handle automatically extracting the response.data property from successful responses */
export const dataResponseInterceptor: Parameters<AxiosInterceptorManager<AxiosResponse>['use']> = [
  response => {
    stop(true);

    if (response.status >= 200 && response.status < 300) {
      return response.data;
    }

    return response;
  },
  error => {
    stop(true);
    return Promise.reject(ApiError.wrap(error));
  },
];
